import { motion, AnimatePresence } from "framer-motion";

export default function DrawerWrapper({ open, close, children }) {
  return (
   <AnimatePresence>
  {open && (
    <>
      <motion.div
        className="fixed inset-0 bg-black/40 z-[1500]"
        onClick={close}
      />

     <motion.div
  className="fixed right-0 top-[80px] h-[calc(100vh-80px)] w-80 bg-white shadow-xl z-[2600] overflow-y-auto"
  initial={{ x: "100%" }}
  animate={{ x: 0 }}
  exit={{ x: "100%" }}
  transition={{ duration: 0.3 }}
>
  {children}
</motion.div>
    </>
  )}
</AnimatePresence>

  );
}
